import { type FC, type ReactNode } from 'react'
import { useIntl } from 'react-intl'

import { type PimVariantAttributeV1 } from '@redteclab/api/clients/bully'

import { variantAttributeAccessorGetLabelText } from '../../../../model/variantAttributeAccessor/variantAttributeAccessorGetLabelText'
import { type SelectionEntry } from '../../../product-page-context/AttributeGroup'

interface ProductPageTextTypeAttributeHeadProps {
  icon?: ReactNode
  metaAttribute: PimVariantAttributeV1
  selectedEntry?: SelectionEntry
  slotBeforeValue?: ReactNode
}

export const ProductPageAttributeHead: FC<
  ProductPageTextTypeAttributeHeadProps
> = ({ icon, metaAttribute, selectedEntry, slotBeforeValue }) => {
  const intl = useIntl()

  const labelText = variantAttributeAccessorGetLabelText(metaAttribute, intl)

  return (
    <div
      className="py-2.5 text-s font-medium leading-l"
      data-qa-id={`product-attribute-${metaAttribute.variant_attribute}`}
    >
      {labelText}
      {': '}
      {slotBeforeValue}
      <span className="mr-3">{selectedEntry?.attribute.value}</span>
      {icon}
    </div>
  )
}
